<template lang="pug">
v-dialog.d-inline(max-width="480" value)
  v-card.text-xs-center
    title-bar(dark) {{ title }}
    v-progress-circular.mt-3(
      :indeterminate="!value"
      :rotate="360"
      :size="100"
      :width="15"
      :value="value"
      color="primary"
    )
    v-card-text {{ text }}
</template>

<script>
import TitleBar from '@/Core/components/TitleBar';

export default {
  components: {
    TitleBar,
  },
  props: {
    completed: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    value() {
      return (this.completed / this.total) * 100;
    },
  },
  data() {
    return {
      title: 'Processing... Please Wait...',
      text:
        'Larger numbers of contacts will take longer to process. Please do not navigate away or close the window while requests are being processed.',
    };
  },
};
</script>
